import React, {useEffect} from 'react';
import './App.css';
import Form from './components/Form'

function App() {

  useEffect(()=>{
  fetch('https://submit-post.herokuapp.com/')
  .then((response) => {
    return response.json();
  })
  .then((data) => {
    console.log(data);
  });
  },[])

  return (
    <div className="App">
      <Form />
    </div>
  );
}

export default App;
